"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBeginImageUploadResult = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateBeginImageUploadResult = (0, validation_1.properties)({
    fields: (0, validation_1.dictionary)((0, validation_1.any)()),
    url: (0, validation_1.text)(),
});
//# sourceMappingURL=BeginImageUploadResult.js.map